import bricks from '../images/banners/everyday-patterns/bricks.jpg';
import curves from '../images/banners/everyday-patterns/curves.jpg';
import pines from '../images/banners/everyday-patterns/pines.jpg';
import rocks from '../images/banners/everyday-patterns/rocks.jpg';
import sand from '../images/banners/everyday-patterns/sand.jpg';
import wood from '../images/banners/everyday-patterns/wood.jpg';

import grandCanyon from '../images/banners/natural-wonders/grand-canyon.jpg';
import greatBarrierReef from '../images/banners/natural-wonders/great-barrier-reef.jpg';
import haLongBay from '../images/banners/natural-wonders/ha-long-bay.jpg';
import himalayas from '../images/banners/natural-wonders/himalayas.jpg';
import namib from '../images/banners/natural-wonders/namib.jpg';
import peritoMoreno from '../images/banners/natural-wonders/perito-moreno.jpg';

import business from '../images/banners/office-scenes/business.svg';
import design from '../images/banners/office-scenes/design.svg';
import engineering from '../images/banners/office-scenes/engineering.svg';
import it from '../images/banners/office-scenes/it.svg';
import office from '../images/banners/office-scenes/office.svg';
import science from '../images/banners/office-scenes/science.svg';

import blur from '../images/covers/abstract/blur.png';
import elements from '../images/covers/abstract/elements.png';
import empty from '../images/covers/abstract/empty.png';
import ideas from '../images/covers/abstract/ideas.png';
import pink from '../images/covers/abstract/pink.png';
import punk from '../images/covers/abstract/punk.png';
import rainbow from '../images/covers/abstract/rainbow.png';
import waves from '../images/covers/abstract/waves.png';
import yellow from '../images/covers/abstract/yellow.png';

import children from '../images/covers/art/children.png';
import city from '../images/covers/art/city.png';
import deer from '../images/covers/art/deer.png';
import dinner from '../images/covers/art/dinner.png';
import gathering from '../images/covers/art/gathering.png';
import ruins from '../images/covers/art/ruins.png';
import stones from '../images/covers/art/stones.png';
import theater from '../images/covers/art/theater.png';
import women from '../images/covers/art/women.png';

import building from '../images/covers/minimal/building.png';
import bulbs from '../images/covers/minimal/bulbs.png';
import ferrisWheel from '../images/covers/minimal/ferris-wheel.png';
import forest from '../images/covers/minimal/forest.png';
import gooses from '../images/covers/minimal/gooses.png';
import greenLeaf from '../images/covers/minimal/green-leaf.png';
import plane from '../images/covers/minimal/plane.png';
import ship from '../images/covers/minimal/ship.png';
import yellowLeaf from '../images/covers/minimal/yellow-leaf.png';
import brandenburgGate from '../images/covers/world-wonders/brandenburg-gate.png';
import eiffelTower from '../images/covers/world-wonders/eiffel-tower.png';
import forbiddenPalace from '../images/covers/world-wonders/forbidden-palace.png';
import goldenGate from '../images/covers/world-wonders/golden-gate.png';
import greatPyramids from '../images/covers/world-wonders/great-pyramids.png';
import himejiCastle from '../images/covers/world-wonders/himeji-castle.png';
import machuPicchu from '../images/covers/world-wonders/machu-picchu.png';
import neuschwanstein from '../images/covers/world-wonders/neuschwanstein.png';
import operaSidney from '../images/covers/world-wonders/opera-sidney.png';
import petra from '../images/covers/world-wonders/petra.png';
import statueOfLiberty from '../images/covers/world-wonders/statue-of-liberty.png';
import tajMahal from '../images/covers/world-wonders/taj-mahal.png';

type ImageDefinition = {
  image: string;
  alt: string;
};

type ImageLibraryGroup = {
  name: string;
  images: ImageDefinition[];
};

export type ImageLibrary = ImageLibraryGroup[];

export const BANNER_IMAGE_LIBRARY: ImageLibrary = [
  {
    name: 'Office Scenes',
    images: [
      { image: design, alt: 'Design' },
      { image: office, alt: 'Office' },
      { image: it, alt: 'IT' },
      { image: business, alt: 'Business' },
      { image: engineering, alt: 'Engineering' },
      { image: science, alt: 'Science' },
    ],
  },
  {
    name: 'Natural Wonders',
    images: [
      { image: grandCanyon, alt: 'Grand Canyon' },
      { image: peritoMoreno, alt: 'Perito Moreno' },
      { image: himalayas, alt: 'Himalayas' },
      { image: namib, alt: 'Namib' },
      { image: haLongBay, alt: 'Ha Long Bay' },
      { image: greatBarrierReef, alt: 'Great Barrier Reefs' },
    ],
  },
  {
    name: 'Everyday Patterns',
    images: [
      { image: curves, alt: 'Curves' },
      { image: sand, alt: 'Sand' },
      { image: pines, alt: 'Pines' },
      { image: wood, alt: 'Wood' },
      { image: rocks, alt: 'Rocks' },
      { image: bricks, alt: 'Bricks' },
    ],
  },
];

export const POST_BANNER_IMAGE_LIBRARY: ImageLibrary = [
  {
    name: 'World Wonders',
    images: [
      { image: petra, alt: 'Petra' },
      { image: machuPicchu, alt: 'Machu Picchu' },
      { image: goldenGate, alt: 'Golden Gate' },
      { image: greatPyramids, alt: 'Great Pyramids' },
      { image: himejiCastle, alt: 'Himeji Castle' },
      { image: statueOfLiberty, alt: 'Statue of Library' },
      { image: operaSidney, alt: 'Opera Sidney' },
      { image: eiffelTower, alt: 'Eiffel Tower' },
      { image: neuschwanstein, alt: 'Neuschwanstein' },
      { image: brandenburgGate, alt: 'Brandenburg Gate' },
      { image: forbiddenPalace, alt: 'Forbidden Palace' },
      { image: tajMahal, alt: 'Taj Mahal' },
    ],
  },
  {
    name: 'Abstract',
    images: [
      { image: yellow, alt: 'Abstract Yellow' },
      { image: waves, alt: 'Abstract Waves' },
      { image: punk, alt: 'Abstract Punk' },
      { image: pink, alt: 'Abstract Pink' },
      { image: ideas, alt: 'Abstract Ideas' },
      { image: empty, alt: 'Abstract Empty' },
      { image: rainbow, alt: 'Abstract Rainbow' },
      { image: elements, alt: 'Abstract Elements' },
      { image: blur, alt: 'Abstract Blur' },
    ],
  },
  {
    name: 'Art',
    images: [
      { image: deer, alt: 'Art Yellow' },
      { image: stones, alt: 'Art Waves' },
      { image: dinner, alt: 'Art Punk' },
      { image: ruins, alt: 'Art Pink' },
      { image: women, alt: 'Art Ideas' },
      { image: gathering, alt: 'Art Empty' },
      { image: children, alt: 'Art Rainbow' },
      { image: theater, alt: 'Art Elements' },
      { image: city, alt: 'Art Blur' },
    ],
  },
  {
    name: 'Minimal',
    images: [
      { image: building, alt: 'Minimal Building' },
      { image: yellowLeaf, alt: 'Minimal Yellow Leaf' },
      { image: forest, alt: 'Minimal Forest' },
      { image: ship, alt: 'Minimal Ship' },
      { image: gooses, alt: 'Minimal Gooses' },
      { image: plane, alt: 'Minimal Plane' },
      { image: bulbs, alt: 'Minimal Bulbs' },
      { image: ferrisWheel, alt: 'Minimal Ferris Wheel' },
      { image: greenLeaf, alt: 'Minimal Green Leaf' },
    ],
  },
];
